<template>
  <div
    v-if="loaded"
    class="content-devx main-dx-pests-diseases-database"
  >
    <DxDataGrid
      id="pestsDiseasesGrid"
      :data-source="pestsDiseasesFormated"
      :column-min-width="90"
      :column-auto-width="true"
      :allow-column-reordering="true"
      :show-borders="true"
      :show-column-lines="true"
      :show-row-lines="true"
      :row-alternation-enabled="true"
      @exporting="onExporting"
      @toolbar-preparing="onToolbarPreparing($event)"
    >
      <DxSelection
        mode="single"
      />
      <DxStateStoring
        :enabled="true"
        type="localStorage"
        storage-key="DxPestsDiseasesDatabase"
      />
      <DxExport
        :enabled="true"
      />
      <DxHeaderFilter :visible="true" />
      <DxPaging :page-size="10" />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="pageSizes"
        :show-info="true"
      />
      <DxSearchPanel
        :visible="true"
        :width="200"
        :placeholder="$t('Search_placeholder')"
      />
      <!--- TODO: Permitir la edición de pests y diseases
      <DxColumn
        v-if="$helpers.havePermission(getPermissions.company_update_master_data)"
        type="buttons"
        data-field="Actions"
      >
        <DxButton
          icon="edit"
          :hint="$t('DxPestsDiseasesDatabase_edit_hint')"
          :on-click="editPestsDiseases"
        />
      </DxColumn>
      -->
      <DxColumn
        data-field="type"
        name="type"
        :caption="$t('DxPestsDiseasesDatabase_column_type')"
        :allow-header-filtering="true"
      />
      <DxColumn
        data-field="name"
        name="name"
        :caption="$t('DxPestsDiseasesDatabase_column_name')"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="scientific_name"
        name="scientific_name"
        :caption="$t('DxPestsDiseasesDatabase_column_scientific_name')"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="symthoms"
        name="symthoms"
        :caption="$t('DxPestsDiseasesDatabase_column_symthoms')"
        :allow-header-filtering="false"
      />
      <DxColumn
        :width="100"
        data-field="photos"
        name="photos"
        :caption="$t('Monitoring_photos')"
        :allow-header-filtering="false"
        cell-template="cellTemplate"
      />
      <template #cellTemplate="{ data }">
        <DxImageScoutingPopup :images="data.value" />
      </template>
    </DxDataGrid>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxSearchPanel,
  DxButton,
  DxExport,
  DxHeaderFilter,
  DxStateStoring,
  DxPager,
  DxSelection,
} from 'devextreme-vue/data-grid';
import { exportDataGrid } from 'devextreme/excel_exporter';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import Api from '../../services/Api';
import DxImageScoutingPopup from './DxImageScoutingPopup.vue';

export default {
  name: 'DxPestsDiseasesDatabase',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSearchPanel,
    DxButton,
    DxExport,
    DxHeaderFilter,
    DxStateStoring,
    DxPager,
    DxSelection,
    DxImageScoutingPopup,
  },
  data() {
    return {
      loaded: false,
      pestsDiseasesFormated: [],
      pageSizes: [5, 10, 20],
    };
  },
  computed: {
    ...mapGetters('scouting', ['getActualPestsDiseases']),
  },
  async beforeMount() {
    this.$f7.preloader.show();
    try {
      const xhr = await Api.getScoutingMasterData(['PESTS', 'DISEASES']);
      const pestsDiseases = JSON.parse(xhr.response).data;
      for (const pestDisease of pestsDiseases) {
        this.pestsDiseasesFormated.push({
          id: pestDisease.id,
          type: pestDisease.type,
          name: pestDisease.name,
          scientific_name: pestDisease.scientific_name,
          symthoms: pestDisease.symthoms,
          photos: pestDisease.photos,
        });
      }
    } catch (e) {
      const message = this.$helpers.getFilteredErrorMessage(e);
      if (message.includes('default_') && !message.includes('404')) {
        this.$f7.dialog.alert(message.split('_').pop());
      } else if (!message.includes('404')) {
        this.$f7.dialog.alert(this.$t(message));
      }
    } finally {
      this.$f7.preloader.hide();
      this.loaded = true;
    }
  },
  methods: {
    createPestsDiseases() {
      this.setActualPestsDiseases({});
      this.$f7.views.main.router.navigate('/createPestsDiseases/', { reloadCurrent: true });
    },
    editPestsDiseases(rowSelected) {
      this.setActualPestsDiseases(rowSelected.row.data);
      this.$f7.views.main.router.navigate('/editPestsDiseases/', { reloadCurrent: true });
    },
    onToolbarPreparing(e) {
      return; // TODO: Permitir la creación de pestes y enfermedades
      if (!this.$helpers.havePermission(this.getPermissions.company_update_master_data)) return;
      e.toolbarOptions.items.unshift({
        location: 'before',
        widget: 'dxButton',
        options: {
          icon: 'add',
          elementAttr: {
            class: 'add-task',
          },
          text: this.$t('DxPestsDiseasesDatabase_button_create_text'),
          onClick: () => {
            this.createPestsDiseases();
          },
        },
      });
    },
    // EXPORT EXCEL
    onExporting(e) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PestsDiseasesDatabase');
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer()
          .then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'PestsDiseasesDatabase.xlsx');
          });
      });
      e.cancel = true;
    },
    ...mapActions('scouting', ['setActualPestsDiseases']),
  },
};
</script>
